import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { environment } from "environment";

// Define a service using a base URL and expected endpoints
export const resourceApi = createApi({
  reducerPath: "resourceApi",
  baseQuery: fetchBaseQuery({
    baseUrl: `${environment.dev.baseUrl}/auth/resources`,
  }),
  endpoints: (builder) => ({
    getResources: builder.query<any, void>({
      query: () => ({
        url: "",
      }),
      transformErrorResponse: (error: any) => error.data.apierror,
    }),
  }),
});

// Export hooks for usage in functional components, which are auto-generated based on the defined endpoints
export const { useGetResourcesQuery, useLazyGetResourcesQuery } = resourceApi;
